import { Loader2 } from "lucide-react";

export function LoadingScreen({ message = "Loading..." }: { message?: string }) {
  return (
    <div className="min-h-[50vh] flex flex-col items-center justify-center text-slate-500">
      <Loader2 className="h-8 w-8 animate-spin mb-4 text-teal-600" />
      <p className="text-sm font-medium">{message}</p>
    </div>
  );
}
